// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"4aef755b","155":"72e1d962","387":"7af5090e","453":"a1c99274","501":"2ce6892d","721":"396fd184","759":"aa1efc54","916":"d10ed979","963":"18cd2a7f","991":"fdb1b116"}[chunkId] + ".chunk.js";
};